// extracted by mini-css-extract-plugin
export default {"form":"CityForm_form__7PQlt","actions":"CityForm_actions__yOphC","deleteButton":"CityForm_deleteButton__PVfBh"};